class ProductOptions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.available_variants = [];
    this.container = this.querySelector('.product-options--container');
    this.first_variant = JSON.parse(this.querySelector('[id*=variant-first--json]').innerHTML);
    this.inputs = this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]');
    this.is_product_page = this.closest('.product-page--root') !== null;
    this.labels = this.querySelectorAll('.disclosure--root, .radios--header');
    this.option_values = [];
    this.size_chart = this.querySelector('.product-options--option .product-size-chart--root');
    this.variants = JSON.parse(this.querySelector('[id*=variant--json]').innerHTML);
    this.root = this.closest(`[data-product-id='${this.dataset.id}']`);

    this.getVariantOptions();
    this.hideOptions(this.first_variant, 0);
    this.disableEmptyOptions();
    this.optionChangeListener();
    this.size_chart && this.moveSizeChart();
  }

  getVariantOptions() {
    this.variants.forEach(
      (variant) => variant.available && this.available_variants.push(variant.options)
    );

    for (let i = 0; i < this.available_variants[0].length; i++) {
      this.option_values[i] = [...new Set(this.available_variants.map((variant) => variant[i]))];
    }
  }

  disableEmptyOptions() {
    const available_options = this.option_values.flat();
    const all_options = this.container.querySelectorAll('.radios--input, .disclosure--option');

    all_options.forEach((option) => {
      const value = this.getOptionValue(option);
      !available_options.includes(value) && option.setAttribute('data-empty', true);
    });
  }

  getOptionValue(option) {
    if (option.getAttribute('data-value')) {
      return option.getAttribute('data-value');
    } else {
      return option.value;
    }
  }

  optionChangeListener() {
    this.inputs.on('change.ProductOptions', ({ target: input }) => {
      const selected_options = [];
      const current_options = this.container.querySelectorAll(
        '[data-item="disclosure"], [data-item="radio"]:checked'
      );

      current_options.forEach((current_option) => {
        const index = current_option.closest('.product-options--option').dataset.index;
        selected_options.push({ index: index, value: current_option.value });
      });

      this.hideOptions(
        selected_options.map((option) => option.value),
        input.closest('.product-options--option').index()
      );

      let variant_found = false;
      this.variants.every((variant) => {
        let options_match = true;

        selected_options.forEach((option) => {
          if (options_match) options_match = variant.options[option.index] === option.value;
        });

        if (options_match) {
          variant_found = variant;
          return false;
        }

        return true;
      });

      this.updateVariant(variant_found);
    });
  }

  updateVariant(variant) {
    if (this.is_product_page) this.updateHistoryState(variant.id);

    // external modules & apps can link in here and access new variant object via event.detail.variant
    const variant_update_event = new CustomEvent('variantUpdated', { detail: variant });
    this.root.dispatchEvent(variant_update_event);
  }

  updateHistoryState(variant_id) {
    let new_variant_url = `${location.origin}${location.pathname}`;

    if (variant_id) new_variant_url += `?variant=${variant_id}`;

    history.replaceState({ path: new_variant_url }, '', new_variant_url);
  }

  hideOptions(selected_options, option_num) {
    const available_options = selected_options.map((option, index) =>
      // returns options in each position that are available for the selected option_num
      this.option_values[index].filter((value) => {
        const temp_variant = [...selected_options];
        temp_variant[index] = value;
        return this.available_variants.some(
          (variant) => variant.join(',') === temp_variant.join(',')
        );
      })
    );

    this.container.childNodes.forEach((option, index) => {
      // grab inputs that aren't in the current option
      if (index != option_num) {
        const input_els = option.querySelectorAll('.radios--input, .disclosure--option');
        input_els.forEach((el) => {
          const value = this.getOptionValue(el);
          // if they aren't in a possible combination of the current option we need to disable them
          el.setAttribute('data-unavailable', !available_options[index].includes(value));
        });
      }
    });
  }

  moveSizeChart() {
    const option_header = this.size_chart.parentNode.querySelector('label').parentNode;
    option_header.appendChild(this.size_chart);
  }
}

customElements.define('product-options-root', ProductOptions);
